/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import trafficMinorOffenceTeaser from "../../../../assets/img/guidebook/Teaser_Ordnungswidrigkeitent_700px.jpg";
import trafficFineTeaser from "../../../../assets/img/guidebook/Teaser_Bussgeldbescheid_700px.jpg";

const guidebookTrafficAccusation = {
  linkTo: "/ratgeber/verkehrsrecht/bussgeldbescheid",
  image: trafficFineTeaser,
  headline: "Professionell gegen Bußgeldbescheid vorgehen",
  text: "Ihnen droht eine Geldstrafe, Punkte oder sogar der Verlust Ihres Führerscheins und Sie wollen wissen, welche Möglichkeiten Sie jetzt haben? Wir erklären Ihnen…",
  altTitle: "Vorwurf anfechten",
};

const guidebookTrafficMinorOffence = {
  linkTo: "/ratgeber/verkehrsrecht/ordnungswidrigkeiten",
  image: trafficMinorOffenceTeaser,
  headline: "Ordnungswidrigkeiten und ihre Strafen",
  text: "Sie erhalten hier einen Überblick darüber, welche Ordnungswidrigkeiten es im Bereich Verkehrsrecht gibt und mit welchen Strafen Sie rechnen...",
  altTitle: "Strafen für Vergehen",
};

export { guidebookTrafficMinorOffence, guidebookTrafficAccusation };
